import { marked } from 'marked'
// 解析md数据
export const parseDataByMd = (companyMd: string) => {
  const arr = []
  let formContent = ''
  let id = 1
  const lines = companyMd.split('\n')

  const flushFormContent = () => {
    if (formContent.trim() && arr.some(x => x.type === 'title')) {
      arr.push({
        type: 'form',
        content: formContent.replaceAll('**', '').replace(/\n$/, ''),
        // eslint-disable-next-line no-plusplus
        id: ++id,
      })
    }
    formContent = ''
  }

  lines.forEach(line => {
    // Regex to find titles like #, ##, ### etc.
    const titleMatch = line.match(/^(#+)\s+(.*)/)
    if (titleMatch) {
      flushFormContent()
      const content = titleMatch[2]
      const isSecTitle = arr.at(-1) && arr.at(-1).type !== 'form'
      // eslint-disable-next-line no-plusplus
      arr.push({ type: 'title', content, id: ++id, isSecTitle })
    } else {
      formContent += `${line}\n`
    }
  })

  flushFormContent() // Don't forget to flush the last form content block
  if (!arr.length) {
    const html = marked.parse(companyMd) as string
    const text = new DOMParser().parseFromString(html, 'text/html').body.textContent
    // eslint-disable-next-line no-plusplus
    arr.push({ type: 'title', content: `企业知识库`, id: ++id })
    // eslint-disable-next-line no-plusplus
    arr.push({ type: 'form', content: text, id: ++id })
  }
  return arr
}
// 解析字符串数据
export const parseDataByStr = (str: string) => {
  // const res = str.split('\n\n')
  // const arr = []
  // let id = 1
  // res.forEach((item, ins) => {
  //   if (ins % 2) {
  //     // eslint-disable-next-line no-plusplus
  //     arr.push({ type: 'form', content: item, id: ++id })
  //   } else {
  //     const [title, subTitle] = item.split('\n\t')
  //     if (title) {
  //       // eslint-disable-next-line no-plusplus
  //       arr.push({ type: 'title', content: title, id: ++id })
  //     }
  //     if (subTitle) {
  //       // eslint-disable-next-line no-plusplus
  //       arr.push({ type: 'title', isSecTitle: true, content: subTitle, id: ++id })
  //     }
  //   }
  // })
  try {
    return JSON.parse(str)
  } catch (error) {
    const arr = parseDataByMd(str)
    return arr
  }
}
// 处理解析数据
export const handleParseData = (arr: { type: string; content: string }[]) => {
  // let str = ''
  // arr.forEach((item, ins) => {
  //   str += item.content
  //   const nextEle = arr[ins + 1]
  //   if (nextEle) {
  //     if (nextEle.type === 'form') {
  //       str += '\n\n'
  //     } else {
  //       str += '\n\t'
  //     }
  //   }
  // })
  return JSON.stringify(arr)
}
// 处理解析详情数据
export const parseDataByStrDetail = (str: string) => {
  const arr = parseDataByStr(str)
  const detailArr = []
  let id = 1
  let obj = { title: '', subTitle: '', content: '' }
  arr.forEach(item => {
    if (item.type === 'title' && item.isSecTitle) {
      if (obj.content) {
        // eslint-disable-next-line no-plusplus
        detailArr.push({ ...obj, id: ++id })
        obj = { title: '', subTitle: '', content: '' }
      }
      obj.subTitle = item.content
    } else if (item.type === 'title') {
      if (obj.content) {
        // eslint-disable-next-line no-plusplus
        detailArr.push({ ...obj, id: ++id })
        obj = { title: '', subTitle: '', content: '' }
      }
      obj.title = item.content
    } else if (item.type === 'form') {
      obj.content += `\n${item.content}`
    }
  })
  // 添加最后一个对象
  if (obj.title || obj.subTitle || obj.content) {
    // eslint-disable-next-line no-plusplus
    detailArr.push({ ...obj, id: ++id })
  }

  return detailArr
}
